import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RouterProvider } from '@tanstack/react-router';

import './design-tokens/tokens.css';
// Imported for its side effect: i18next must be initialised before the first component renders.
import './i18n';
import { registerServiceWorker } from './pwa/register';
import { router } from './router';

/**
 * TanStack Query owns all server state. There is deliberately no global store — client state stays
 * local to the feature that owns it (docs/engineering/09-frontend.md).
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Private planning data is authoritative and must be fresh; the PWA caches shell and static
      // assets only, never private data (ADR-005).
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

registerServiceWorker();

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
